import axios from '@/libs/api.request'
const sales = {
  // 营业额，客单数，客单价，上班人数
  getSales: (data) => {
    return axios.post({
      url: '/Sales',
      data: data
    })
  },
  // 时间段销量
  getRealTimeSales: (data) => {
    return axios.post({
      url: '/Sales/RealTime',
      data: data // + axios.parseParams(data)
    })
  },
  // 单品时间段销量
  getProductRealTime: (data)=>{
    return axios.post({
      url: '/Sales/ProductRealTime',
      data: data
    })
  },
  // 销售明细
  getSalesDetail: (data) => {
    return axios.post({
      url: '/Sales/Detail',
      data: data
    })
  },
  // 销售明细
  getSalesProductDetail: (data) => {
    return axios.get({
      url: '/Sales/ProductDetail?' + axios.parseParams(data)
    })
  },
  // 各门店库销量
  getSalesByDept: (data) => {
    return axios.get({
      url: '/Sales/Dept?' + axios.parseParams(data)
    })
  },
  // 实时预警
  getSalesWarning: (data) => {
    return axios.get({
      url: '/Sales/Warning?' + axios.parseParams(data)
    })
  }
}
export default sales



// WEBPACK FOOTER //
// ./src/api/api-sales.js